import { FetchStatus } from '@powdr/constants';

import { TERRAINS_PENDING, TERRAINS_SUCCESS, TERRAINS_ERROR } from '../types';

const initialState = {
  data: null,
  status: FetchStatus.IDLE,
  error: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case TERRAINS_PENDING:
      return {
        ...state,
        status: FetchStatus.LOADING,
      };
    case TERRAINS_SUCCESS:
      return {
        ...state,
        data: action.payload,
        status: FetchStatus.SUCCESS,
      };
    case TERRAINS_ERROR:
      return {
        status: FetchStatus.ERROR,
        error: action.payload,
      };
    default: return state;
  }
};
